module.exports = __webpack_public_path__ + "img/btn1.f2ea57bd.png";